import { render, staticRenderFns } from "./CampaignStatusBadge.vue?vue&type=template&id=3cbd4f04&scoped=true"
import script from "./CampaignStatusBadge.vue?vue&type=script&lang=js"
export * from "./CampaignStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatusBadge.vue?vue&type=style&index=0&id=3cbd4f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbd4f04",
  null
  
)

export default component.exports